import type { ZodType, ZodTypeDef, z } from 'zod'

/** Return the value if it is valid, otherwise return null */
export function validate<T extends ZodType<unknown, ZodTypeDef, unknown>>(
  schema: T,
  value: Record<string, unknown>,
): z.output<T> | null {
  const result = schema.safeParse(value)

  if (result.success) {
    return result.data
  }

  console.warn('Zod validation error', result.error.issues, value)

  return null
}
